module.exports = __webpack_public_path__ + "static/media/ice-tomato.93dcc97c.png";